import { useEffect, useState } from 'react';
import useHttp from '../../../../hooks/use-http';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';
import GridProvider from './components/GridProvider';
import Inputs from './components/Inputs';
import { urls } from './api/urls';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../../shared/api/handleErrorMessage';
import { useTranslation } from 'react-i18next';
import Dokumenta from '../components/Dokumenta/Dokumenta';
import { formatDateToDB } from '../../../../../utils/FormatDate';

const INITIAL_VALUES = {
  id: 0,
  idDok: 0,
  naziv: '',
  iznos: '',
  cena: '',
  opis: '',
  idKorProm: 0,
  idVrstaUsluge: 0,
  nazivUsluge: '',
  kolicina: '',
  jm: null,
};

const Troskovi = ({ idRn, naplacujeSe }) => {
  const { t, i18n } = useTranslation();
  const { sendRequest, data, getData, isLoading } = useHttp('');

  const [formValue, setFormValue] = useState(INITIAL_VALUES);
  const [files, setFiles] = useState([]);
  const [openDialogForm, setOpenDialogForm] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openDialogDokumenta, setOpenDialogDokumenta] = useState(false);

  const vratiStavke = () => {
    const config = {
      method: 'POST',
      url: urls.VRATI_STAVKE_ZA_RN,
      data: { id: idRn },
    };
    sendRequest(config);
  };
  useEffect(() => {
    vratiStavke();
  }, []);
  const handleOpenDokumenta = (item) => {
    setFormValue(item);
    setOpenDialogDokumenta(true);
  };
  const handleOpenDeleteDialog = (id) => {
    setFormValue((curr) => {
      return { ...curr, id: id };
    });
    setOpenDeleteDialog(true);
  };
  const handleCloseDelete = () => {
    setFormValue(INITIAL_VALUES);
    setOpenDeleteDialog(false);
  };
  const handleOpenDialogForm = (item) => {
    if (item.id > 0) {
      setFormValue(item);
    } else {
      setFormValue(INITIAL_VALUES);
    }
    setOpenDialogForm(true);
  };
  // #region [color1] Blok koga za dokumenta
  const getDokument = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_DOKUMENT,
      data: {
        idObjekta: formValue.id,
        objekat: 'RNTroskovi',
      },
    };
    const result = await getData(config);
    setFiles(result);
    console.log(result);
  };
  useEffect(() => {
    getDokument();
  }, [formValue.id]);

  const handleSaveDokument = async (id = 0) => {
    if (files.length > 0 && id > 0) {
      const fd = new FormData();
      fd.append('IdVrsteDokOpste', 0);
      fd.append('objekat', 'RNTroskovi');
      fd.append('IdObjekta', id);
      fd.append('NazivFajla', null);
      fd.append('IdJezika', 0);
      fd.append('Kategorija', null);
      fd.append('Datum', formatDateToDB(new Date()));
      fd.append('IdKorProm', +localStorage.idKorisnika);
      files.forEach((item) => {
        fd.append('Dokumenti', item);
      });

      const config = {
        method: 'POST',
        url: urls.INSERT_DOKUMENTA,
        data: fd,
      };

      const result = await getData(config);
      setFiles([]);
      console.log(result);
    }
  };
  const handleUkloniFile = async (item) => {
    console.log(item);
    const config = {
      method: 'POST',
      url: urls.DELETE_DOKUMENT,
      data: { id: item.id },
    };
    const result = await getData(config);
    getDokument();
    setFormValue((curr) => {
      return { ...curr, nazivFajla: '' };
    });
  };
  // #endregion
  const handleSave = async () => {
    const config = {
      method: 'POST',
      url: formValue.id > 0 ? urls.UPDATE_STAVKE : urls.INSERT_STAVKE,
      data: {
        ...formValue,
        idKorProm: +localStorage.getItem('idKorisnika'),
        idDok: idRn,
        iznos: naplacujeSe ? +formValue.iznos : 0,
        cena: +formValue.cena,
        kolicina: +formValue.kolicina,
      },
    };

    const result = await getData(config);
    if (result.id > 0) {
      handleSaveDokument(result.id);
      vratiStavke();
      setFormValue(INITIAL_VALUES);
      toast.success(
        formValue.id === 0 ? 'Uspešan unos podatak' : 'Uspešna izmena podataka',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_STAVKE,
      data: { id: formValue.id },
    };
    const result = await getData(config);
    if (result > 0) {
      toast.success('Uspešano obrisan podatak');
      setFormValue(INITIAL_VALUES);
      setOpenDeleteDialog(false);
      vratiStavke();
      return;
    }
    toast.error('Greška prilikom brisanja podatka');
  };
  return (
    <div>
      <GridProvider
        data={data}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleOpenDialogForm={handleOpenDialogForm}
        handleOpenDokumenta={handleOpenDokumenta}
        isLoading={isLoading}
        naplacujeSe={naplacujeSe}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDialogForm}
        title="Unos troškova"
        content={
          <Inputs
            formValue={formValue}
            setFormValue={setFormValue}
            idRn={idRn}
            file={files}
            setFile={setFiles}
            handleUkloniFile={handleUkloniFile}
            naplacujeSe={naplacujeSe}
          />
        }
        handleClose={() => setOpenDialogForm(false)}
        handleConfirm={handleSave}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="xl"
        open={openDialogDokumenta}
        title="Dokumenta"
        content={
          <Dokumenta
            formValue={formValue}
            openDialogDokumenta={openDialogDokumenta}
            metadata="RNTroskovi"
          />
        }
        handleClose={() => setOpenDialogDokumenta(false)}
        // handleConfirm={handleSave}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Troskovi;
